export const HERO_TAGS = [
  '12+ лет в маркетинге',
  '7 лет в управлении',
  '7 стран',
  '200 000$/мес бюджет',
];

export const PULL_STATS = [
  { num: '12+', label: 'лет в маркетинге, из них 7 — в управлении структурами' },
  { num: '7', label: 'стран — Казахстан, Кыргызстан, Узбекистан, Россия, Беларусь, Турция, Тайланд' },
  { num: '200K$', label: 'бюджет портфеля проектов под управлением в месяц' },
  { num: '9/10', label: 'коллег считают профессионалом и рекомендуют' },
];

export const BIO_PARAGRAPHS = [
  'Я маркетолог по призванию. Начинала специалистом по контекстной рекламе — сама руками запускала сотни кампаний в Google, Яндекс, Meta, ВКонтакте и TikTok. За 12 лет прошла путь до руководителя digital-направления, управляя бюджетами портфеля проектов до 200 000 долларов в месяц.',
  'Работала в digital-агентствах и крупных структурах — в индустриях Automotive, FMCG, финансы, недвижимость, e-commerce. География — Казахстан, Кыргызстан, Узбекистан, Россия, Беларусь, Турция и Тайланд.',
  'Я пропагандирую маркетинг на основе данных и математики — не ощущений и не «креативных гипотез», а конкретных цифр, которые можно посчитать и проверить.',
];

export const TIMELINE = [
  {
    company: 'ASTER Group',
    role: 'Бренд-менеджер → Senior Digital → Руководитель digital-маркетинга',
    desc: 'Стратегия и тактика продвижения 15 автобрендов и дилерской сети в Казахстане, Узбекистане и Беларуси. Управляла командой из 5 человек. Выстроила процессы так, что весь портфель брендов обслуживался качественно без расширения штата.',
  },
  {
    company: 'Operation Mastery',
    role: 'Руководитель маркетинга',
    desc: 'Международный SaaS-стартап. Разработала концепцию и философию бренда, позиционирование и стратегию с нуля.',
  },
  {
    company: 'Trusty Labs',
    role: 'Руководитель отдела платного трафика',
    desc: 'Рекламное агентство. Команда до 10 человек. Агентство выросло в объёме проектов в 4 раза — при росте штата только в 2 раза.',
  },
  {
    company: 'Jusan',
    role: 'Антикризисное ведение рекламы',
    desc: 'В сложный период банковской экосистемы за пару дней собрала команду и 3 месяца удалённо вела все рекламные кампании по банковскому ритейлу, Jusan Магазин и B2B-направлению — пока бизнес не сформировал внутреннюю команду.',
  },
];

export const BRAND_GROUPS = [
  { industry: 'FMCG', brands: 'Pepsi · Huggies · Kotex · Malyutka · NAN · EFES · Nivea · Mary Kay · и другие' },
  {
    industry: 'Финансовый сектор',
    brands: 'Eurasian Bank · Kazkom · Halyk Bank · Jusan · MyCredit · Swiss Capital',
  },
  { industry: 'E-commerce', brands: 'Proteinshop · Besmartshop · Jmart · Tickets Kazakhstan · Tickets Turkey' },
  { industry: 'Недвижимость', brands: 'BI Group · Exclusive Group · RAMS · Global' },
  {
    industry: 'Автомобили',
    brands: 'Aster Auto · LADA · Nissan · OMODA & JAECOO · Changan · JAC · Chevrolet',
  },
];

export const VALUES = [
  {
    icon: 'M',
    title: 'Системное мышление',
    desc: 'Вижу маркетинг одновременно сверху и изнутри — прошла путь от исполнителя до стратега.',
  },
  {
    icon: 'H',
    title: 'Честность',
    desc: 'Говорю как есть, даже если правда неудобная. Беру на себя ответственность за результат.',
  },
  {
    icon: 'D',
    title: 'Данные, а не ощущения',
    desc: 'Любое решение обосновано расчётом. Пропагандирую маркетинг на основе математики.',
  },
  {
    icon: 'V',
    title: 'Вовлечённость',
    desc: 'Глубоко погружаюсь в бизнес клиента — не работаю по шаблону без понимания контекста.',
  },
  {
    icon: 'N',
    title: 'Умение договариваться',
    desc: 'Открыто проговариваю сложные моменты — с командой, клиентом, партнёрами.',
  },
  {
    icon: 'S',
    title: 'Стратегия + операционка',
    desc: 'Работаю на стыке стратегии и операционной эффективности — не только думаю, но и делаю руками.',
  },
];

export const ACHIEVEMENTS = [
  { num: '9/10', label: 'удовлетворённость сотрудников отделом' },
  { num: '4×', label: 'рост объёма проектов при штате ×2 — за счёт автоматизации' },
  { num: '6+ мес', label: 'LTV клиента в агентстве за счёт выстроенных процессов' },
  { num: '1,5 года', label: 'среднее время работы сотрудника в команде — выше среднего по индустрии' },
];

export const EDUCATION = [
  'Экономический колледж — диплом с отличием',
  '«Базовый курс по маркетингу» — НИУ ВШЭ, онлайн-обучение',
  '«Маркетинг на основе данных. Руководитель маркетинга» — академия Ильи Балахнина',
  'Постоянно самообучаюсь — много читаю профессиональную литературу по маркетингу и управлению',
];

export const BOOKS = ['Customer Experience', 'Клиенты на всю жизнь', 'Найден более быстрый маршрут'];

export const SEGMENTS = [
  {
    tag: 'Малый бизнес',
    title: 'Консультации',
    desc: 'Разовые и диагностические консультации. Разбираем цифры, находим точки роста, определяем с чего начать.',
    fill: true,
  },
  {
    tag: 'Средний бизнес',
    title: 'Фракционный директор',
    desc: 'Приглашённый руководитель маркетинга — выстраиваю систему и управляю на результат на постоянной основе.',
    fill: false,
  },
  {
    tag: 'Средний бизнес',
    title: 'Директор на аутсорсе',
    desc: 'Полноценное управление маркетинговой функцией без найма штатного директора в команду.',
    fill: false,
  },
];

export const PREVIEW_STATS = [
  { num: '12+', label: 'лет в маркетинге' },
  { num: '7', label: 'стран опыта' },
  { num: '200K$', label: 'бюджет в месяц' },
];
